// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"293":"ccf7dbe1ca867b5d6337","453":"1696053d22b4914317c6"}[chunkId] + ".js";
};